// components/marketplace/Pagination.tsx
"use client";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onLoadMore: () => void;
  showLoadMore: boolean;
}

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  onLoadMore,
  showLoadMore,
}: PaginationProps) {
  return (
    <div className="mt-8 flex flex-col items-center">
      {/* Page Numbers */}
      <div className="flex space-x-2 mb-4">
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              page === currentPage
                ? "bg-[#002301] text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            {page}
          </button>
        ))}
      </div>

      {/* Load More Button */}
      {showLoadMore && (
        <button
          onClick={onLoadMore}
          className="bg-[#002301] text-white px-6 py-3 rounded-full hover:bg-[#001a00] transition-colors duration-200 cursor-pointer hover:scale-105"
        >
          Load More
        </button>
      )}
    </div>
  );
}
